import { HeroSection, ServicesPillars, VeteransSection, AIAssistSection, FounderStrip, CtaBand } from "@/components/marketing/HomeSections";

export default function Home() {
  return (
    <div className="fade-in-up">
      <HeroSection />
      <ServicesPillars />
      <VeteransSection />
      <AIAssistSection />
      <FounderStrip />
      <CtaBand />
    </div>
  );
}
